import { Serializable } from "./serializable";

export default class Region implements Serializable<Region> {
  id?: string;
  name?: string;

  deserialize(input: any): Region {
    if (input != null) {
      this.id = input.id;
      this.name = input.name || null;
    }
    return this;
  }
}
